import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Extend to make compatible with custom values from globals.css
// @see https://github.com/dcastil/tailwind-merge
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      breakpoint: ['3xl', '4xl'],
      color: [
        // Miista colors
        'miista-neutral-50',
        'miista-neutral-100',
        'miista-red-500',
        'miista-red-700',
        'miista-orange-500',
        'miista-green-500',
        'miista-yellow-100',
        'miista-purple-50',
        // Shadcn/ui colors
        'background',
        'foreground',
        'card',
        'card-foreground',
        'popover',
        'popover-foreground',
        'primary',
        'primary-foreground',
        'secondary',
        'secondary-foreground',
        'muted',
        'muted-foreground',
        'accent',
        'accent-foreground',
        'destructive',
        'destructive-foreground',
        'border',
        'input',
        'ring',
      ],
      spacing: [
        'miista-page-padding',
        'miista-page-padding-content',
        'miista-navigation-height',
        'miista-navigation-margin-y',
        'miista-content-offset-static',
        'miista-button-height-default',
        'miista-button-height-large',
        'miista-button-height-small',
        'miista-button-padding-x-default',
        'miista-button-padding-x-small',
        'miista-product-preview-inner',
        'miista-grid-item-padding-mobile-x',
        'miista-grid-item-padding-mobile-y',
        'miista-grid-item-padding-desktop-x',
        'miista-grid-item-padding-desktop-y',
      ],
    },
  },
})

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}
